import { useRef, useEffect } from 'react';
import { getItemId } from './listUtils.js';

function useKeepElementVisible(items, itemKeyProperty, onShowLastItem, currentItem) {
    const itemsObserverRef = useRef();
    const itemsPositionRef = useRef({});
    useEffect(() => {
        if (items && window.IntersectionObserver) {
            const lastId = getItemId(items[items.length - 1], itemKeyProperty);
            itemsObserverRef.current = new window.IntersectionObserver(((entries) => {
                entries.forEach((element) => {
                    itemsPositionRef.current[element.target.id] = { isIntersecting: element.intersectionRatio > 0.9 };
                    if (element.intersectionRatio > 0 && element.target.id === lastId && onShowLastItem) {
                        onShowLastItem();
                    }
                });
            }), { threshold: [0] });
            items.forEach((item) => {
                const id = getItemId(item, itemKeyProperty);
                const element = document.getElementById(id);
                if (element) {
                    itemsObserverRef.current.observe(element);
                }
            });
        }
        const observer = itemsObserverRef.current;
        return () => {
            if (observer) {
                observer.disconnect();
            }
        };
    }, [itemKeyProperty, items, onShowLastItem]);
    useEffect(() => {
        if (currentItem) {
            const elementId = getItemId(currentItem, itemKeyProperty);
            if (itemsPositionRef.current[elementId] && !itemsPositionRef.current[elementId].isIntersecting) {
                const element = document.getElementById(elementId);
                if (element && typeof element.scrollIntoView === 'function') {
                    element.scrollIntoView({
                        behavior: 'smooth',
                    });
                }
            }
        }
    }, [currentItem, itemKeyProperty]);
}

export { useKeepElementVisible as default };
